import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartClusterBar"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 22.5H3C2.60218 22.5 2.22064 22.342 1.93934 22.0607C1.65804 21.7794 1.5 21.3978 1.5 21V1.5H3V21H22.5V22.5Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M9 12H7.5V19.5H9V12zM6.75 16.5H5.25V19.5H6.75V16.5zM21 6H19.5V19.5H21V6zM18.75 10.5H17.25V19.5H18.75V10.5zM11.25 19.5H12.75L12.75 9H11.25L11.25 19.5zM13.5 19.5H15V13.5H13.5V19.5z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartClusterBar.vue"]]);
